































import { Component, Prop, Vue } from 'vue-property-decorator';
import { Merchant } from '@/types/interfaces/merchant';
import { networkSvc, merchantSvc } from '@/services';

@Component({
  name: 'network-merchants'
})
export default class NetworkMerchants extends Vue {
  @Prop({ type: Array, required: true, default: () => [] })
  private activeMerchants!: Merchant[];

  @Prop({ required: true })
  private networkId!: number;

  isLoading: Boolean = false;
  merchants: Merchant[] = [];
  selectedMerchantId: number | null = null;

  async removeMerchant(merchant: Merchant) {
    this.isLoading = true;
    let result = await networkSvc.removeMerchantFromNetwork(
      merchant.id as number,
      this.networkId
    );
    this.$notify.success(result.message);
    this.activeMerchants.splice(this.activeMerchants.indexOf(merchant), 1);
    this.isLoading = false;
  }

  mounted() {
    this.loadAllMerchants();
  }

  async loadAllMerchants() {
    this.isLoading = true;
    this.merchants = await merchantSvc.getAllMerchants();
    this.isLoading = false;
  }

  async addMerchant() {
    this.isLoading = true;
    await networkSvc.addMerchantToNetwork(
      this.selectedMerchantId as number,
      this.networkId
    );
    this.activeMerchants.push(this.merchants.find(
      merchant => merchant.id === this.selectedMerchantId
    ) as Merchant);
    this.selectedMerchantId = null;
    this.isLoading = false;
  }

  get filteredMerchants() {
    return this.merchants.filter(merchant =>
      this.activeMerchants.every(
        activeMerchant => activeMerchant.id !== merchant.id
      )
    );
  }
}
